module.exports = __webpack_public_path__ + "img/ico-book.a1c45979.svg";